<script setup>
import {
  ref,
  reactive,
  onBeforeMount,
  toRefs,
  computed,
  watchEffect,
} from 'vue';
import { commonStore } from '@/store/common';
import { hexPalette } from '@/utils/color.js';
import { balanceUtil, getXY, getFullTime, getUrl } from '@/utils';
import countDown from './countDown.vue';
import { Toast } from 'vant';
import { useI18n } from 'vue-i18n';
const common_store = commonStore();
const props = defineProps({
  pixelInfo: Object,
  name: String,
  btnText: String,
  btnType: String,
  type: String,
  count: String || Number,
  endDate: String,
});
const { t } = useI18n();
const emit = defineEmits(['toSell', 'toCancel']);
const { pixelInfo, endDate, count } = toRefs(props);
const tokenid = pixelInfo.value?.tokenId || pixelInfo.value.tokenid;
const inTime = ref(false);
const toSell = async () => {
  if (+count >= 9) {
    return;
  }
  data.hashType = 'sell';
  data.alertShow = true;
  data.finish = false;
  data.success = false;
  try {
    const res = await common_store.allMethods.getApproved(tokenid).call();
    if (res == common_store.market_address) {
      sell();
    } else {
      //授权弹框
      // const res = await common_store.allMethods
      //   .approve(common_store.market_address, pixelInfo.value.tokenid)
      //   .send({ from: common_store.address });
      common_store.setEmpowerType(2, tokenid);
      common_store.showEmpower(true);
    }
  } catch (error) {
    console.log(error);
    Toast(error);
  }
};
const sell = async () => {
  data.alertShow = true;
  data.finish = false;
  data.success = false;
  try {
    const sellRes = await common_store.marketMethods
      .sell(tokenid)
      .send({ from: common_store.address });
    // router.go(-1);
    data.finish = true;
    data.success = true;
    data.hash = sellRes.transactionHash;
    common_store.addHash(data.hash, 1);
  } catch (error) {
    data.finish = true;
    data.success = false;
    data.hash = error.message;
  }
};
const toCancel = async () => {
  data.alertShow = true;
  data.hashType = 'cancel';
  data.finish = false;
  data.success = false;
  try {
    const res = await common_store.marketMethods
      .cancel(pixelInfo.value.id)
      .send({ from: common_store.address });
    data.finish = true;
    data.success = true;
    data.hash = res.transactionHash;
    common_store.addHash(data.hash, 4);
  } catch (error) {
    data.finish = true;
    data.success = false;
    data.hash = error.message;
  }
};
const closeFn = () => {
  data.alertShow = false;
};

const noOpen = () => {
  Toast(t('notOpen'));
};
watchEffect(() => {
  if (count.value >= 3) {
    inTime.value = false;
  }
  if (endDate.value) {
    inTime.value =
      +endDate.value * 1000 + 10 * 24 * 60 * 60000 > new Date().getTime();
  } else {
    inTime.value = false;
  }
});
</script>
<template>
  <div
    class="pixel-item listBg"
    :class="type !== 'home' ? 'commonWidth' : 'homeWidth'"
  >
    <div class="pixel-item_img">
      <img :src="getUrl(tokenid)" alt="" class="" />
      <div class="item_color middleAll center" v-if="type == 'hold'">
        <span class="Wcolor positionAll font-Three"
          >{{ hexPalette[pixelInfo.color - 1] }}
        </span>
      </div>
    </div>
    <ul>
      <li class="flex_between">
        <div class="flex_start">
          <span
            class="color-btn pixel_x"
            v-show="type == 'hold'"
            :style="{ background: hexPalette[pixelInfo.color - 1] }"
          ></span>
          <span class="font-One Wcolor pixel_x pixel_xy"
            >X:{{ getXY(pixelInfo.id).x }}</span
          >
          <span class="font-One Wcolor pixel_xy"
            >Y:{{ getXY(pixelInfo.id).y }}</span
          >
        </div>
        <div class="flex_start">
          <span v-if="name == 'nft'" class="font-Three pixel_price mainColor">
            {{ common_store.priceArr[count] }}</span
          >
          <span v-else class="font-Three pixel_price mainColor">
            {{ Number(balanceUtil(pixelInfo.price)).toFixed(2) }}
          </span>
          <span class="font-One pixel_xy priceColor price">SKYT</span>
        </div>
      </li>
      <li class="Wcolor flex_between">
        <span class="font-Two">#{{ tokenid }}</span>
        <span
          class="Wcolor font-One"
          v-if="name == 'market' && pixelInfo.seller"
          >{{ pixelInfo.seller.slice(0, 4) }}...{{
            pixelInfo.seller.slice(-4)
          }}</span
        >
      </li>
      <!-- <li v-if="type !== 'hold'">
        <span class="Wcolor font-Two">
          {{ getFullTime(pixelInfo.selltime) }}</span
        >
      </li> -->
      <li class="pixel-btn" v-if="type !== 'hasBuy' && name == 'nft'">
        <van-button
          :type="btnType"
          block
          size="small"
          @click.stop="$emit('toSell', tokenid)"
          v-show="
            type == 'hold' && !inTime && pixelInfo.type_ <= 2 && count < 9
          "
          >{{ $t(btnText) }}</van-button
        >
        <van-button
          type="primary"
          :disabled="true"
          block
          size="small"
          v-if="
            (type == 'hold' && pixelInfo.type_ == '3') ||
            (type == 'hold' && count >= 9)
          "
          @click="noOpen"
        >
          {{ $t('NFT.notSell') }}
        </van-button>
        <count-down
          @click.stop=""
          :endDate="endDate"
          v-show="type == 'hold' && inTime && pixelInfo.type_ <= 2 && count < 9"
          @close="inTime = false"
          class="countdown font-Four"
        ></count-down>

        <!-- 删除次数判断，改为type_,type_< 3可出售，反之可质押，暂未开放 -->
        <!-- <van-button
          :type="btnType"
          block
          size="small"
          :disabled="+count >= 3"
          @click.stop="$emit('toSell', pixelInfo.tokenid)"
          v-show="(type == 'hold' && !inTime) || count >= 3"
          >{{ count >= 3 ? $t('NFT.notSell') : $t(btnText) }}</van-button
        >
        <count-down
          @click.stop=""
          :endDate="endDate"
          v-show="type == 'hold' && inTime && count < 3"
          @close="inTime = false"
          class="countdown font-Four"
        ></count-down> -->
        <van-button
          type="primary"
          v-show="type == 'sell'"
          block
          size="small"
          @click.stop="$emit('toCancel', pixelInfo.id, pixelInfo.tokenId)"
          >{{ $t(btnText) }}</van-button
        >
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.homeWidth {
  width: 100%;
  ul {
    padding: 10px 0;
  }
}
.commonWidth {
  width: calc((100% - 10px) / 2);
  margin-bottom: 10px;
  ul {
    padding: 10px 8px 15px 8px;
  }
}
.pixel-item {
  border-radius: 8px;
  &_img {
    position: relative;
    font-size: 0;
    min-height: 80px;
    img {
      width: 100%;
    }
  }

  li {
    height: 24px;
    line-height: 24px;
  }
}
.price_icon {
  width: 8px;
  height: 14px;
}
.color-btn {
  width: 10px;
  height: 10px;
}
.pixel_x {
  margin-right: 5px;
}
.pixel-btn {
  margin-top: 10px;
}
.price {
  margin-left: 4px;
}
.item_color {
  display: inline-block;
  width: 120px;
  height: 25px;
  line-height: 25px;
  background: rgba($white, 0.3);
  border: 1px solid $white;
  opacity: 1;
  border-radius: 19px;
  bottom: 10px;
  overflow: hidden;
  // -webkit-filter: blur(1px);
  span {
    z-index: 99;
  }
  &::after {
    content: '';
    width: 120px;
    height: 25px;
    background: url('../assets/marketImg/pixel-icon.png');
    background-position: center bottom;
    background-size: cover;
    background-attachment: fixed;
    position: absolute;
    filter: blur(4px);
    top: 0;
    left: 0;
  }
}
.pixel_xy {
  transform: scale(0.85);
}

.countdown {
  height: 30px;
  line-height: 30px;
}
</style>
